"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassifyModalBreadCrumbs = void 0;
const react_1 = __importStar(require("react"));
const icons_material_1 = require("@mui/icons-material");
const breadcrumbs_styles_1 = require("./breadcrumbs.styles");
const localization_1 = require("../../../../../localization");
const utils_1 = require("../../../../../utils");
const ClassifyModalBreadCrumbs = ({ node, taxonomyNodes, onClearNode, selectedNodeId, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const currentNodePath = (0, react_1.useMemo)(() => {
        if (node) {
            const taxonomyNodesMap = new Map(taxonomyNodes.map((item) => [item.id, item]));
            return (0, utils_1.getNodePath)(taxonomyNodesMap, node);
        }
        return [];
    }, [node, taxonomyNodes]);
    const title = node === null || node === void 0 ? void 0 : node.title;
    const isSelectedNode = (node === null || node === void 0 ? void 0 : node.id) !== selectedNodeId;
    const showClearButton = title && selectedNodeId && !isSelectedNode;
    return (react_1.default.createElement(breadcrumbs_styles_1.StyledBreadcrumbsWrapper, null, react_1.default.createElement(breadcrumbs_styles_1.StyledWripperTitle, null, react_1.default.createElement(breadcrumbs_styles_1.StyledTitle, { variant: "caption" }, t({ key: 'CLASSIFY_MODAL_SELECTED_CLASS' })), showClearButton && react_1.default.createElement(breadcrumbs_styles_1.StyledButton, { onClick: onClearNode }, t({ key: 'CLEAR' }))), react_1.default.createElement(breadcrumbs_styles_1.StyledClassName, { variant: "body1" }, title || t({ key: 'CLASSIFY_MODAL_TITLE_NOT_SELECTED' })), react_1.default.createElement(breadcrumbs_styles_1.StyledBreadcrumbs, { separator: react_1.default.createElement(icons_material_1.NavigateNext, null), "aria-label": "breadcrumb" }, currentNodePath === null || currentNodePath === void 0 ? void 0 : currentNodePath.map((item) => (react_1.default.createElement(breadcrumbs_styles_1.StyledBreadcrumbsItem, { variant: 'caption', key: item.id }, item.title))))));
};
exports.ClassifyModalBreadCrumbs = ClassifyModalBreadCrumbs;
exports.default = exports.ClassifyModalBreadCrumbs;
